import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { url } from "../../baseUrl.js";

export const requestResetEmail = createAsyncThunk(
  "passwordReset/requestEmail",
  async ({ email, role, lang }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${url}/api/auth/forgot-password`, {
        email,
        role,
        lang,
      });
      return data.message;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error sending email"
      );
    }
  }
);

export const submitNewPassword = createAsyncThunk(
  "passwordReset/submitNewPassword",
  async ({ token, password }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${url}/api/auth/reset-password`, {
        token,
        password,
      });
      return data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Reset failed");
    }
  }
);
